import { MemoizedSelector, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Cutting, CuttingTemplate } from '../../../../../core/model';
import { PyStateUtils } from '../../../../../core/state';
import { CartState, CuttingState, StateWithCart } from '../cart-state';
import { getCartState } from './feature.selector';

export const getCuttingState: MemoizedSelector<StateWithCart, CuttingState> = createSelector(
  getCartState,
  (state: CartState) => state && state.cutting
);

export const getCuttingPricesState: MemoizedSelector<StateWithCart, StateUtils.EntityLoaderState<Cutting>> = createSelector(
  getCuttingState,
  (state: CuttingState) => state.prices
);

export const getCuttingPriceStateFactory = (key: string): MemoizedSelector<StateWithCart, StateUtils.LoaderState<Cutting>> => {
  return createSelector(
    getCuttingPricesState,
    (state) => (state && PyStateUtils.entityLoaderStateSelector(state, key)) || PyStateUtils.initialLoaderState
  );
};

export const getCuttingPriceFactory = (key: string): MemoizedSelector<StateWithCart, Cutting | undefined> => {
  return createSelector(
    getCuttingPriceStateFactory(key),
    (state) => (state && StateUtils.loaderValueSelector(state)) || undefined
  );
};

export const getCuttingPriceLoadingFactory = (key: string): MemoizedSelector<StateWithCart, boolean> => {
  return createSelector(getCuttingPriceStateFactory(key), (state) => StateUtils.loaderLoadingSelector(state));
};

export const getCuttingPriceLoadedFactory = (key: string): MemoizedSelector<StateWithCart, boolean> => {
  return createSelector(getCuttingPriceStateFactory(key), (state) => StateUtils.loaderSuccessSelector(state));
};

export const getCuttingTemplatesState: MemoizedSelector<
  StateWithCart,
  StateUtils.EntityLoaderState<CuttingTemplate>
> = createSelector(getCuttingState, (state: CuttingState) => state.templates);

export const getCuttingTemplateStateFactory = (
  key: string
): MemoizedSelector<StateWithCart, StateUtils.LoaderState<CuttingTemplate>> => {
  return createSelector(
    getCuttingTemplatesState,
    (state) => (state && PyStateUtils.entityLoaderStateSelector(state, key)) || PyStateUtils.initialLoaderState
  );
};

export const getCuttingTemplateFactory = (key: string): MemoizedSelector<StateWithCart, CuttingTemplate | undefined> => {
  return createSelector(
    getCuttingTemplateStateFactory(key),
    (state) => (state && StateUtils.loaderValueSelector(state)) || undefined
  );
};

export const getCuttingTemplateLoadingFactory = (key: string): MemoizedSelector<StateWithCart, boolean> => {
  return createSelector(getCuttingTemplateStateFactory(key), (state) => StateUtils.loaderLoadingSelector(state));
};

export const getCuttingTemplateLoadedFactory = (key: string): MemoizedSelector<StateWithCart, boolean> => {
  return createSelector(getCuttingTemplateStateFactory(key), (state) => StateUtils.loaderSuccessSelector(state));
};
